var render = function render(){var _vm=this,_c=_vm._self._c;return _c('busWitnessTable',{attrs:{"busWitnessTableType":_vm.businessType},on:{"update:busWitnessTableType":function($event){_vm.businessType=$event},"update:bus-witness-table-type":function($event){_vm.businessType=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }